import messages from '../locales/zh_Hans_CN.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'zh-Hans-CN',
};
export default lang;
